// Copyright (C) 2019-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

const config = {
    backendAPI: '/api',
    proxy: false,
    organizationID: null,
    origin: '',
    uploadChunkSize: 100,
};

export default config;
